export const pmsConstants = [
  { value: 'topsOrtho', label: 'topsOrtho' },
  { value: 'Dolphin', label: 'Dolphin' },
  { value: 'Cloud9', label: 'Cloud9' },
  { value: 'OrthoTracV2', label: 'OrthoTracV2' },
  { value: 'OpenDental', label: 'OpenDental' },
  { value: 'none', label: 'No PMS' },
]

const allProducts = [
  {
    value: 'dso',
    label: 'DSO',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: true,
    },
    showInTopsPortal: false,
  },
  {
    value: 'openchair',
    label: 'New Patient OS',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: false,
      OpenDental: true,
      none: true,
    },
    showInTopsPortal: true,
  },
  {
    value: 'patientportal',
    label: 'Existing Patient OS',
    pmsEligible: {
      topsOrtho: false,
      Dolphin: false,
      Cloud9: true,
      OrthoTracV2: false,
      OpenDental: false,
      none: false,
    },
    showInTopsPortal: false,
  },
  {
    value: 'reminders',
    label: 'Appointment Reminders',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: false,
    },
    showInTopsPortal: true,
  },
  {
    value: 'reminderstier2',
    label: 'Reminders Tier 2',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: false,
    },
    showInTopsPortal: false,
  },
  {
    value: 'topsremindersplus',
    label: 'topsReminders+',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: false,
      Cloud9: false,
      OrthoTracV2: false,
      OpenDental: false,
      none: false,
    },
    showInTopsPortal: true,
  },
  {
    value: 'reviews',
    label: 'Reviews',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: false,
    },
    showInTopsPortal: false,
  },
  {
    value: 'voip',
    label: 'Screen Pop (VoIP)',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: true,
    },
    showInTopsPortal: true,
  },
  {
    value: 'textingonly',
    label: 'Texting',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: true,
    },
    showInTopsPortal: true,
  },
  {
    value: 'crm',
    label: 'CRM',
    pmsEligible: {
      topsOrtho: true,
      Dolphin: true,
      Cloud9: true,
      OrthoTracV2: true,
      OpenDental: true,
      none: true,
    },
    showInTopsPortal: false,
  },
]

// used by dashboard and products page
export function productConstants(isTopsAdmin = false) {
  return isTopsAdmin
    ? allProducts.filter(product => product.showInTopsPortal)
    : allProducts
}



// WEBPACK FOOTER //
// ./src/common/constants.js